import useSWR from 'swr'

import type {
  ComputeEngineReport,
  ComputeEngineHealthMetricAdvice,
  ComputeEngineHealthLogAdvice
} from '@clinic/client'
import { getHealthReportDetail } from '~/api'

export type HealthReportResponseContent = ComputeEngineReport
export type HealthReportMetricAdvice = ComputeEngineHealthMetricAdvice
export type HealthReportLogAdvice = ComputeEngineHealthLogAdvice

const REPORT_DETAIL_CACHE_KEY = 'cluster-health-report-detail'

/**
 * Hook for getting a health report detail
 */
export function useGetReportContent({
  orgId,
  clusterId,
  reportId
}: {
  orgId: string
  clusterId: string
  reportId: string
}) {
  const { data, error, mutate } = useSWR(
    {
      cacheId: REPORT_DETAIL_CACHE_KEY,
      orgId,
      clusterId,
      reportId
    },
    (args) =>
      getHealthReportDetail({
        orgId: args.orgId,
        clusterId: args.clusterId,
        reportId: args.reportId
      })
  )

  return {
    data: data ?? {},
    isLoading: !error && !data,
    isError: !!error,
    error,
    mutate
  }
}
